

export const stockDocParser = (stockDocs) => {
    let updatedStockDocs = []
    if (stockDocs.length){
        updatedStockDocs = stockDocs.map(eachStockDoc => {
            let newStockDoc = {}
            if(eachStockDoc?.docQty){
                newStockDoc.docQty = parseFloat(eachStockDoc.docQty)
            }
            if(eachStockDoc?.pendingQty){
                newStockDoc.pendingQty = parseFloat(eachStockDoc.pendingQty)
            }
            if(eachStockDoc?.inProcessQty){
                newStockDoc.inProcessQty = parseFloat(eachStockDoc.inProcessQty)
            }
            if(eachStockDoc?.invoicePendingQty){
                newStockDoc.invoicePendingQty = parseFloat(eachStockDoc.invoicePendingQty)
            }
            if(eachStockDoc?.invoicedQty){
                newStockDoc.invoicedQty = parseFloat(eachStockDoc.invoicedQty)
            }
            if(eachStockDoc?.adjustedQty){
                newStockDoc.adjustedQty = parseFloat(eachStockDoc.adjustedQty)
            }
            if(eachStockDoc?.CNDNQty){
                newStockDoc.CNDNQty = parseFloat(eachStockDoc.CNDNQty)
            }
            if(eachStockDoc?.convertedQty){
                newStockDoc.convertedQty = parseFloat(eachStockDoc.convertedQty)
            }
            if(eachStockDoc?.dispatchedQty){
                newStockDoc.dispatchedQty = parseFloat(eachStockDoc.dispatchedQty)
            }
            return {...eachStockDoc, ...newStockDoc}
        })
    }

    return updatedStockDocs
}

export const stockWarehousesParser = (stockWarehouses) => {
    const updatedStockWarehouses = stockWarehouses.map(eachStockWarehouse => {
        let newStockWarehouse = {}
        if(eachStockWarehouse?.inStock){
            newStockWarehouse.inStock = parseFloat(eachStockWarehouse.inStock)
        }
        if(eachStockWarehouse?.smartStock){
            newStockWarehouse.smartStock = parseFloat(eachStockWarehouse.smartStock)
        }
        if(eachStockWarehouse?.outStock){
            newStockWarehouse.outStock = parseFloat(eachStockWarehouse.outStock)
        }
        if(eachStockWarehouse?.dispatchedStock){
            newStockWarehouse.dispatchedStock = parseFloat(eachStockWarehouse.dispatchedStock)
        }
        if(eachStockWarehouse?.rejectedStock){
            newStockWarehouse.rejectedStock = parseFloat(eachStockWarehouse.rejectedStock)
        }
        if(eachStockWarehouse?.discardedStock){
            newStockWarehouse.discardedStock = parseFloat(eachStockWarehouse.discardedStock)
        }
        if(eachStockWarehouse?.lastSmartPrice){
            newStockWarehouse.lastSmartPrice = parseFloat(eachStockWarehouse.lastSmartPrice)
        }
        if(eachStockWarehouse?.lastRejectedPrice){
            newStockWarehouse.lastRejectedPrice = parseFloat(eachStockWarehouse.lastRejectedPrice)
        }
        if(eachStockWarehouse?.smartStockPrice){
            newStockWarehouse.smartStockPrice = parseFloat(eachStockWarehouse.smartStockPrice)
        }
        if(eachStockWarehouse?.lastOutStockPrice){
            newStockWarehouse.lastOutStockPrice = parseFloat(eachStockWarehouse.lastOutStockPrice)
        }
        if(eachStockWarehouse?.outStockPrice){
            newStockWarehouse.outStockPrice = parseFloat(eachStockWarehouse.outStockPrice)
        }

        return {...eachStockWarehouse, ...newStockWarehouse}
    })

    return updatedStockWarehouses
}

export const smartStockMovesParser = (smartStockMoves) => {
    const updatedSmartStockMoves = smartStockMoves.map(eachSmartStockMove => {
        let newSmartStockMove = {}
        if(eachSmartStockMove?.moveQty){
            newSmartStockMove.moveQty = parseFloat(eachSmartStockMove.moveQty)
        }
        if(eachSmartStockMove?.price){
            newSmartStockMove.price = parseFloat(eachSmartStockMove.price)
        }

        return {...eachSmartStockMove, ...newSmartStockMove}
    })

    return updatedSmartStockMoves
}